module.exports = __webpack_public_path__ + "img/line-logo.ee0f3f44.svg";